import { missionApi } from "@/core/apis";

// getter types
export const MISSIONS = "missions";

// action types
export const GET_MISSIONS = "getMissions";

// mutation types
const SET_MISSIONS = "setMissions";

const state = {
  missions: []
};

const getters = {
  [MISSIONS](state) {
    return state.missions;
  }
};

const actions = {
  [GET_MISSIONS](context) {
    return new Promise(resolve => {
      missionApi.getAllMission().then(response => {
        context.commit(SET_MISSIONS, response);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_MISSIONS](state, missions) {
    state.missions = missions;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
